import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface EditStoreOwnerModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const EditStoreOwnerModal: React.FC<EditStoreOwnerModalProps> = ({
  open,
  onClose,
  children,
  title,
  size = 'md',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={size}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              color: 'text.primary',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ p: 1.5 }}>{children}</Box>
      </DialogContent>
    </Dialog>
  );
};

export default EditStoreOwnerModal;
